export default class Name {

	public constructor (private firstName: string, private lastName: string) {}

	public getFirstName () {
		return this.firstName;
	}

	public getLastName () {
		return this.lastName;
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/users/domain/aggregates/user/Name.ts